import type { WarrantyConfig } from '#types/config/components/form/warranty'

export default {
  hasMerchandiseCredit: true
} satisfies WarrantyConfig
